import { render } from "./RecoverPasswordView.vue?vue&type=template&id=43607500&scoped=true"
import script from "./RecoverPasswordView.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordView.vue?vue&type=script&lang=js"

import "./RecoverPasswordView.vue?vue&type=style&index=0&id=43607500&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43607500"]])

export default __exports__